export const getSurveys = (obj) => ({
  type: "GET_SURVEYS",
  obj,
});

export const getSurveysSuccess = (data) => ({
  type: "GET_SURVEYS_SUCCESS",
  data,
});

export const getSurveysFail = (error) => ({
  type: "GET_SURVEYS_FAIL",
  error,
});

export const surveyApproval = (obj) => ({
  type: "SURVEY_APPROVAL",
  obj,
});

export const surveyApprovalSuccess = (data) => ({
  type: "SURVEY_APPROVAL_SUCCESS",
  data,
});

export const surveyApprovalFail = (error) => ({
  type: "SURVEY_APPROVAL_FAIL",
  error,
});
